// @ts-ignore
import config from '../../temp/config';

export const GET_COURSE_CARDS = `
query GetCourseCards(
  $datasource: String!
  $contextItem: String!
  $topicId: String
  $countryCode: String
) {
  taxConfiguration: item(path: "/sitecore/content/CPA/Corporate/Settings/Country Tax Configuration") {
    taxSettings: children {
      ... on CountryTaxSetting {
        country {
          value
        }
        countryCode {
          value
        }
        taxLabel {
          value
        }
        taxPercentage {
          value
        }
      }
    }
  }

  datasource: item(path: $datasource) {
    ...datasourceFields
  }
 
  contextItem: item(path: $contextItem) {
    id
    name
 
    children(includeTemplateIDs: ["64B82609-C0CB-48F8-ACBF-93C440317819"]) {
      id
      name
      displayName
      url
 
      ... on CourseTopicPage {
        topic {
          ... on LookupField {
            targetItem {
              id
              name
              displayName
            }
          }
        }
      }
    }
  }
}

fragment datasourceFields on CourseCardListAutopopulated {
  heading {
    jss
  }
  description {
    jss
  }
  seeMore {
    jss
  }
 
  items(topicId: $topicId, countryCode: $countryCode) {
    id
    type
    title
    rating
    format
    marketingImageURL
    courseReason
    startDate
    endDate
    cpdHours
    description
    link
    listingImage {
      value {
        alt
        height
        src
        width
      }
    }
    icon
    coursePriceType
    courseMemberPrice
    courseCurrencyCode
    countryPrices {
      regionKey
      memberPrice
      fSPrice
      nonMemberPrice
      currencyCode
    }
    templateName
    published
    readingTime
    tags {
      id
      displayName
    }
  }
}
`;

export const fetchCourses = async (
  topicId: string,
  datasource: string,
  contextItem: string,
  countryCode?: string
): Promise<{ topics: any[]; items: any[]; taxConfiguration?: any }> => {
  try {
    const apiKey = config.sitecoreApiKey || "{0994FF40-7336-4069-BEAD-E596A53562A1}";
    const endpoint = `/api/corporate?sc_apikey=${apiKey}`;

    // We use relative path so it seamlessly works on the client domain
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        query: GET_COURSE_CARDS,
        variables: {
          datasource: datasource,
          contextItem: contextItem,
          topicId: topicId || "",
          countryCode: countryCode || ""
        }
      })
    });

    const json = await response.json();

    const contextChildren = json?.data?.contextItem?.children || [];
    const topicsFromChildren = contextChildren.reduce((acc: any[], child: any) => {
      if (child?.topic?.targetItem) {
        acc.push({
          ...child.topic.targetItem,
          url: child.url
        });
      }
      return acc;
    }, []);

    return {
      topics: topicsFromChildren,
      items: json?.data?.datasource?.items || [],
      taxConfiguration: json?.data?.taxConfiguration
    };
  } catch (error) {
    console.error("Error dynamically fetching courses list:", error);
    return { topics: [], items: [], taxConfiguration: undefined };
  }
};
